import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import validate from './Validate';
import DynamicNavigationTabs from '../../../shared/components/DynamicNavigationTabs';
import EvaluativeActivitiesGridMaintenance from './EvaluativeActivitiesGridMaintenance';
import ConsolidationGridMaintenance from './ConsolidationGridMaintenance';
import PresenceGridMaintenance from '../../../shared/components/PresenceGridMaintenance';
import SmartButton from '../../../shared/components/SmartButton';
import { ACTIVE_TAB } from '../../../shared/utils/constants';

const CycleClosingForm = (props) => {
  const {
    t,
    handleSubmit,
    dto,
    initialize,
    evaluationClosingWrapper,
    change,
    attendanceWrapper,
    step,
    turnBackStep,
    backHandler,
    nextStep,
    showLoading,
    hideLoading,
  } = props;
  const [notificationAlert, setNotificationAlert] = useState({});

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  useEffect(() => {
    change('step', step);
  }, [step]);

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <DynamicNavigationTabs
          step={step}
          nextStep={nextStep}
          disabledConditional={!dto.cycleClosed}
        >
          <EvaluativeActivitiesGridMaintenance
            title={t('general.evaluative-activities')}
            evaluationClosingWrapper={evaluationClosingWrapper}
            dto={dto}
            notificationAlert={notificationAlert}
            setNotificationAlert={setNotificationAlert}
            change={change}
          />
          <PresenceGridMaintenance
            title={t('general.presence-grid')}
            header={{ cycleName: dto.cycleName, subjectName: dto.subject.name }}
            disabled={dto.cycleClosed}
            change={change}
            attendanceWrapper={attendanceWrapper}
          />
          <ConsolidationGridMaintenance
            title={t('general.consolidation')}
            dto={dto}
            showLoading={showLoading}
            hideLoading={hideLoading}
          />
        </DynamicNavigationTabs>

        <ButtonToolbar className="form__button-toolbar">
          <SmartButton
            label={
              step === ACTIVE_TAB.ONE
                ? t('general.back')
                : t('general.turn-back')
            }
            color="primary"
            onClick={
              step === ACTIVE_TAB.ONE || dto.cycleClosed
                ? () => backHandler()
                : () => turnBackStep()
            }
          />
          {!dto.cycleClosed && (
            <SmartButton
              type="submit"
              disabled={dto.cycleClosed}
              label={
                step === ACTIVE_TAB.THREE
                  ? t('general.confirm-shutdown')
                  : t('general.save-advance')
              }
              color="success"
            />
          )}
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

CycleClosingForm.propTypes = {
  t: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  evaluationClosingWrapper: PropTypes.shape(PropTypes.shape).isRequired,
  attendanceWrapper: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  turnBackStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
};

export default reduxForm({
  form: 'CycleClosingForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(CycleClosingForm));
